import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import { fadeIn } from '../../Functions/GlobalAnimations';
import Buttons from '../../Components/Button/Buttons';
import SideButtons from '../../Components/SideButtons';
import { Col, Container, Row } from 'react-bootstrap';
import { Parallax } from 'react-scroll-parallax';
import { m } from 'framer-motion';
import Overlap from '../../Components/Overlap/Overlap';
import axios from 'axios';
import config from '../../config';
import Markdown from "react-markdown";

import gfm from "remark-gfm";

const Apropos = (props) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  const direction = isRtl ? 'rtl' : 'ltr';

  const [pageData, setPageData] = useState({
    title: { fr: "", ar: "" },
    description: { fr: "", ar: "" },
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPageApropos = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${config.SITE_API_URL}/page_aprops`,
        { headers: { 'x-api-key': config.SITE_API_KEY } }
      );
      const data = response?.data?.result || { title: { fr: "", ar: "" }, description: { fr: "", ar: "" } };
      setPageData(data);
    } catch (err) {
      console.error("Erreur lors du chargement de la page À propos :", err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPageApropos();
  }, [i18n.language]); // Re-fetch si la langue change (au cas où l'API gère le multilangue)

  // Sélection dynamique du titre et de la description selon la langue
  const currentTitle = isRtl ? pageData.title.ar : pageData.title.fr;
  const currentDescription = isRtl ? pageData.description.ar : pageData.description.fr;

  return (
    <div style={{...props.style, direction: direction}}>
      <SideButtons />
      {/* Parallax Scrolling Start */}
      <m.div className="h-[380px] overflow-hidden sm:h-[365px] relative" {...fadeIn}>
        <Parallax
          className="lg-no-parallax bg-cover absolute top-0 left-0 w-full h-full"
          translateY={[-40, 40]}
          style={{ backgroundImage: `url(/assets/img/webp/portfolio-bg.webp)` }}
        />
        <Container className="h-full relative">
          <Row className="items-stretch justify-center h-[450px] md:h-[375px] sm:h-[350px]">
            <Col xl={6} lg={7} md={8} xs={12} className="text-center flex justify-center flex-col">
              <h2 className="text-blue-900 mb-[0px] font-serif font-medium -tracking-[1px] my-auto xs:mb-[0px]">
                <Markdown remarkPlugins={[gfm]}>
                  {isLoading
                    ? t('apropos.loading')
                    : error
                    ? t('apropos.error')
                    : currentTitle || t('apropos.page_title')}
                </Markdown>
              </h2>
            </Col>
          </Row>
        </Container>
      </m.div>
      {/* Parallax Scrolling End */}

      {/* قسم الصورة */}
      <section className="" {...fadeIn}>
        <Container fluid>
          <Row className="justify-center">
            <Col>
              <img
                loading="lazy"
                className="mx-auto"
                src="/img/apropos.png"
                alt={t('apropos.image_alt')}
                width="1490"
                height="550"
              />
            </Col>
          </Row>
        </Container>
      </section>
      {/* نهاية قسم الصورة */}

      {/* قسم المحتوى */}
      <section>
        <Container className="xs:px-0 mb-[5%]">
          <m.div className="row justify-center sm:mx-0" {...fadeIn}>
            <Overlap value={50}>
              <Col
                lg={9}
                className="shadow-[0_0_20px_rgba(0,0,0,0.08)] bg-white items-center justify-center p-24 md:p-12 mx-auto"
              >
                <Row className="items-center justify-center lg:mx-0 xs:px-0 xs:text-center">
                  <Col
                    xl={7}
                    lg={5}
                    md={6}
                    className="md:mb-[50px] sm:mx-[40px] flex justify-center xs:my-[40px]"
                  >
                    <div className="inline-block text-center w-[300px] py-14 px-[15px] relative border-solid border-[10px] border-[#f29f2f]">
                      <div
                        className="w-[95%] leading-[50px] font-semibold text-blue-900 text-xxl font-serif relative inline-block align-middle"
                        style={{ textAlign: isRtl ? 'right' : 'left' }}
                      >
                        {t('apropos.partner_title')}
                      </div>
                    </div>
                  </Col>
                  <Col xl={5} md={6} sm={11} className="sm:mx-[20px] xs:mx-0 xs:px-0">
                    <p
                      className="mb-[40px] sm:mb-[30px] text-blue-700"
                      style={{ textAlign: isRtl ? 'right' : 'left' }}
                    >
                      <Markdown remarkPlugins={[gfm]}>
                        {isLoading
                          ? t('apropos.loading')
                          : error
                          ? t('apropos.error')
                          : currentDescription || t('apropos.defaultDescription', { defaultValue: '' })}
                      </Markdown>
                    </p>
                    <a
                href="/course"
                className={`block w-50 py-3.5 text-center rounded-lg font-semibold text-base transition-all duration-300 hover:scale-[1.03] bg-[#f29f2f] text-[#003479] hover:bg-gray-100`}
              >
                {t('apropos.consult_courses')}
              </a>
                  </Col>
                </Row>
              </Col>
            </Overlap>
          </m.div>
        </Container>
      </section>
      {/* نهاية قسم المحتوى */}
    </div>
  );
};

export default Apropos;